import Hotjar from '@hotjar/browser';

const siteId = 1039513;
const hotjarVersion = 6;

Hotjar.init(siteId, hotjarVersion);
